import { useGetSupervisorProjectDetailsQuery } from '../api/supervisorProjectsApiSlice';

export const useSupervisorProjectsDataGridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetSupervisorProjectDetailsQuery> => {
  return useGetSupervisorProjectDetailsQuery();
};
